var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZendesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_18313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3913 4.13965V13.0607H0L7.3913 4.13965Z",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3913 0.939453C7.3913 2.97809 5.73913 4.62955 3.6996 4.62955C1.66008 4.62955 0 2.97809 0 0.939453H7.3913Z",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60864 13.0607C8.60864 11.0221 10.2608 9.37061 12.3003 9.37061C14.3399 9.37061 15.992 11.0221 15.992 13.0607H8.60864Z",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60864 9.86048V0.939453H15.9999L8.60864 9.86048Z",
    fill: "#03363D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_18313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12.1212,
    fill: "white",
    transform: "translate(0 0.939453)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendesk);
export default __webpack_public_path__ + "static/media/Zendesk.45dc5563673610ba9c81b21afeecccdd.svg";
export { ForwardRef as ReactComponent };